import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, ClusterIcon } from "@libs/rubick";
import { ArrowTopRightOnSquareIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import { useSystemErrorsSelectors } from "../../app/utils/systemErrorUtils";
import { useAppSelector } from "../../app/hooks";
import { useApi } from "../../app/apiContext";
import { shallowEqual } from "react-redux";
export function WorkerNodeView({ controlPlaneUrl }) {
    // Subscribe to the SSE system-status stream so system_errors are populated
    const { statusApi } = useApi();
    statusApi.useGetStatusQuery();
    const { selectSystemErrorMsgs } = useSystemErrorsSelectors();
    const systemErrors = useAppSelector(selectSystemErrorMsgs, shallowEqual);
    const isOrphaned = systemErrors.some((msg)=>typeof msg === "string" && msg.includes("ORPHANED NODE"));
    return /*#__PURE__*/ _jsx("div", {
        className: "flex items-center justify-center p-8 min-h-[calc(100vh-8rem)]",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "max-w-lg w-full text-center",
            children: [
                isOrphaned && /*#__PURE__*/ _jsx("div", {
                    className: "mb-6 text-left",
                    children: /*#__PURE__*/ _jsxs(Alert, {
                        title: "Orphaned Node",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: "This node has been removed from the cluster and can no longer communicate with the control plane."
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                className: "mt-2",
                                children: [
                                    "To make this node usable again, delete",
                                    " ",
                                    /*#__PURE__*/ _jsx("code", {
                                        className: "bg-red-100 px-1 rounded text-sm",
                                        children: "/var/lib/entropy/auth.db"
                                    }),
                                    " ",
                                    "and",
                                    " ",
                                    /*#__PURE__*/ _jsx("code", {
                                        className: "bg-red-100 px-1 rounded text-sm",
                                        children: "/var/lib/entropy/kv.db"
                                    }),
                                    " ",
                                    "then restart the service."
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "flex justify-center mb-4",
                    children: /*#__PURE__*/ _jsx(ClusterIcon, {
                        className: "w-16 h-16"
                    })
                }),
                /*#__PURE__*/ _jsx("h1", {
                    className: "text-3xl font-bold text-gray-900 mb-2",
                    children: "Worker Node"
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text-gray-600 mb-8",
                    children: "This node is a worker in a cluster. Cluster management is available on the control plane."
                }),
                /*#__PURE__*/ _jsxs("a", {
                    href: `${controlPlaneUrl}/cluster`,
                    className: "inline-flex items-center gap-2 rounded-lg bg-navy-90 px-6 py-3 text-white hover:bg-navy-80 transition-colors",
                    children: [
                        "Go to Control Plane",
                        /*#__PURE__*/ _jsx(ArrowTopRightOnSquareIcon, {
                            className: "h-5 w-5"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "mt-6 flex items-start gap-2 text-left rounded-lg bg-blue-50 p-4",
                    children: [
                        /*#__PURE__*/ _jsx(InformationCircleIcon, {
                            className: "h-5 w-5 text-blue-500 shrink-0 mt-0.5"
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            className: "text-sm text-blue-700",
                            children: [
                                "You will be redirected to the control plane at",
                                " ",
                                /*#__PURE__*/ _jsx("span", {
                                    className: "font-medium",
                                    children: controlPlaneUrl
                                }),
                                ". You may need to log in separately."
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
